import { useEffect } from "react";

import { claimTtvConversionCompletion } from "@/app/(application)/(normal)/create/ttvConversionCompletions/claimTtvConversionCompletion";
import { readTtvConversionSoundIds } from "@/app/(application)/(normal)/create/ttvConversionSoundIds/readTtvConversionSoundIds";
import { captureTtvEvent } from "@/app/(application)/(ttv)/ttv/analytics/captureTtvEvent";
import type { ConversionConstructedNoDates } from "@/types/types";
import { useIsImpersonating } from "@/utils/impersonation/useIsImpersonating";

// Closes the TTV funnel once per conversion in this tab, across Output remounts and reloads, whether it renders as the newest result or further down in the history.
export const useTrackTtvConversionCompletions = (
  conversions: ConversionConstructedNoDates[] | null
): void => {
  const isImpersonating = useIsImpersonating();
  useEffect(() => {
    if (conversions === null || isImpersonating) {
      return;
    }
    const transferredSoundIds = readTtvConversionSoundIds();
    for (const conversion of conversions) {
      const soundId = conversion.inputSound?.id ?? null;
      if (
        soundId === null ||
        !transferredSoundIds.has(soundId) ||
        !conversion.confirmedDone ||
        conversion.failed ||
        !claimTtvConversionCompletion(conversion.id)
      ) {
        continue;
      }
      captureTtvEvent({
        event: "conversion_completed",
        conversionId: conversion.id,
        soundId,
        transferId: transferredSoundIds.get(soundId) ?? null,
      });
    }
  }, [conversions, isImpersonating]);
};
